import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { clsx } from "clsx";
import { forwardRef } from "react";
import { CloseIcon } from "../../icons/index.js";
import { UnStyledButton } from "../button/index.js";
import { usePortalContainer } from "../portal/index.js";
import * as D from "@radix-ui/react-dialog";
import { Root } from "@radix-ui/react-visually-hidden";
/* empty css          */
const DialogClose = forwardRef((props, ref) => {
  const $ = c(8);
  let t0;
  if ($[0] !== props.className) {
    t0 = clsx("graphiql-dialog-close", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /* @__PURE__ */ jsx(Root, { children: "Close dialog" });
    t2 = /* @__PURE__ */ jsx(CloseIcon, {});
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== ref || $[6] !== t0) {
    t3 = /* @__PURE__ */ jsx(D.Close, { asChild: true, children: /* @__PURE__ */ jsxs(UnStyledButton, { ...props, ref, type: "button", className: t0, children: [
      t1,
      t2
    ] }) });
    $[4] = props;
    $[5] = ref;
    $[6] = t0;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
});
DialogClose.displayName = "Dialog.Close";
const DialogHeader = forwardRef((t0, ref) => {
  const $ = c(14);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = clsx("graphiql-dialog-header", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children) {
    t2 = typeof children === "string" ? /* @__PURE__ */ jsx(D.Title, { className: "graphiql-dialog-title", children }) : children;
    $[6] = children;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /* @__PURE__ */ jsx(DialogClose, {});
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props || $[10] !== ref || $[11] !== t1 || $[12] !== t2) {
    t4 = /* @__PURE__ */ jsxs("div", { ...props, ref, className: t1, children: [
      t2,
      t3
    ] });
    $[9] = props;
    $[10] = ref;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
});
DialogHeader.displayName = "Dialog.Header";
const DialogBody = forwardRef((t0, ref) => {
  const $ = c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = clsx("graphiql-dialog-body", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== ref || $[9] !== t1) {
    t2 = /* @__PURE__ */ jsx("div", { ...props, ref, className: t1, children });
    $[6] = children;
    $[7] = props;
    $[8] = ref;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
});
DialogBody.displayName = "Dialog.Body";
const DialogFooter = forwardRef((t0, ref) => {
  const $ = c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = clsx("graphiql-dialog-footer", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== ref || $[9] !== t1) {
    t2 = /* @__PURE__ */ jsx("div", { ...props, ref, className: t1, children });
    $[6] = children;
    $[7] = props;
    $[8] = ref;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
});
DialogFooter.displayName = "Dialog.Footer";
const DialogRoot = (t0) => {
  const $ = c(16);
  let children;
  let props;
  let restoreFocusRef;
  if ($[0] !== t0) {
    ({
      children,
      restoreFocusRef,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = restoreFocusRef;
  } else {
    children = $[1];
    props = $[2];
    restoreFocusRef = $[3];
  }
  const container = usePortalContainer();
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /* @__PURE__ */ jsx(D.Overlay, { className: "graphiql-dialog-overlay" });
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== restoreFocusRef) {
    t2 = restoreFocusRef ? (event) => {
      const target = restoreFocusRef.current;
      if (target) {
        event.preventDefault();
        target.focus();
      }
    } : void 0;
    $[5] = restoreFocusRef;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== t2) {
    t3 = /* @__PURE__ */ jsx(D.Content, { className: "graphiql-dialog", onCloseAutoFocus: t2, children });
    $[7] = children;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== container || $[11] !== t3) {
    t4 = /* @__PURE__ */ jsxs(D.Portal, { container, children: [
      t1,
      t3
    ] });
    $[10] = container;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== props || $[14] !== t4) {
    t5 = /* @__PURE__ */ jsx(D.Root, { ...props, children: t4 });
    $[13] = props;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
const Dialog = Object.assign(DialogRoot, {
  Close: DialogClose,
  Title: D.Title,
  Trigger: D.Trigger,
  Description: D.Description,
  Header: DialogHeader,
  Body: DialogBody,
  Footer: DialogFooter
});
export {
  Dialog
};
//# sourceMappingURL=index.js.map
